export default "__VITE_ASSET__mO97GhRV__"